<template>
    <el-dialog
        :visible.sync="detail.dialog"
        custom-class="dailogCustomerBase"
        width="50%"
    >
        <template slot="title">
            <h1 class="text-header">ประวัติการทำรายการ</h1>
        </template>
        <form-create-qr-payment
            :isCreate.sync="detail.isCreate"
            :detail.sync="detail"
        ></form-create-qr-payment>
        <el-row>
            <el-col :span="24" class="text-md-left mb-16">
                <span class="text-bold">QR Code สำหรับชำระเงิน</span>
            </el-col>
            <el-col :span="24">
                <el-row type="flex" align="center" justify="center">
                    <div v-if="detail.detail !== null && detail.detail.qrCodeImageUrl">
                        <qr-payment
                            :historyDetail.sync="detail.detail"
                            :userCode.sync="detail.userCode"
                        ></qr-payment>
                    </div>
                    <el-row v-else type="flex" align="center" justify="center">
                        <div class="expired-qr-card">
                            <img class="expired-qr-img" src="@/assets/all-customer/expiredQR.png">
                        </div>
                    </el-row>
                </el-row>
            </el-col>
        </el-row>
        <span
            slot="footer"
            class="dialog-footer"
        >
            <el-button type="primary" @click="detail.dialog = false">ปิดหน้านี้</el-button>
        </span>
    </el-dialog>
</template>

<script>
import FormCreateQrPayment from './FormCreateQrPayment.vue'
import QrPayment from './QrPayment.vue'
export default {
    name: 'paymentDetail',
    components: {
        QrPayment,
        FormCreateQrPayment
    },
    props: {
        detail: {
            type: Object
        },
        historyDetail: {
            type: Object,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
.text-header {
    margin:unset;
    text-align:left;
}
.expired-qr-card {
    height: 248px;
    width: 248px;
    background: #fff;
    padding: 12px;
    .expired-qr-img {
        width: 100%;
        height: auto;
    }
}
::v-deep .divider-dash {
    border: 1px dashed #D1D5E0;
    background-color: transparent !important;
}
</style>
<style lang="scss">
.dailogCustomerBase {
    .el-dialog__header {
        background-color: teal;
        color: white;
        button {
            font-size: large;
            i {
                color: #ffffff;
                &:hover {
                    color: white;
                }
            }
        }
    }
    .el-dialog__footer {
        width: 90%;
    }
}
.mb-16 {
    margin-bottom: 16px;
}
</style>
